import React, { AllHTMLAttributes, HTMLAttributes, PropsWithChildren } from "react";
import classnames from "classnames";

type FlexProps = {
    row?: boolean;
    column?: boolean;
    center?: boolean;
    end?: boolean;
    between?: boolean;
    alignCenter?: boolean;
    alignEnd?: boolean;
    g?: number;
    wrap?: boolean;
    reverse?: boolean;
    shrink?: boolean;
    grow?: boolean;
}

type BoxProps = PropsWithChildren & {
    wFull?: boolean;
    wFullVw?: boolean;

    hFull?: boolean;
    hFullVh?: boolean;
    className?: string;
    style?: React.CSSProperties;
}

type FlexBox = HTMLAttributes<HTMLDivElement> & FlexProps & BoxProps;

export const VStack = (props: FlexBox) => <Flex column {...props} />;
export const HStack = (props: FlexBox) => <Flex row {...props} />;

export const Flex = (props: FlexBox) => {
    const {
        style,
        className,
        row,
        column,
        alignCenter,
        alignEnd,
        shrink,
        wrap,
        reverse,
        g,
        wFull,
        wFullVw,
        hFull,
        hFullVh,
        center,
        end,
        grow,
        between,
        ...rest
    } = props;

    const _style = {
        display: 'flex',
        maxWidth: '100%',
        width: style?.width ?? width(props),
        height: style?.height ?? height(props),
        flexDirection: (row ? 'row' : column ? 'column' : 'row') as any,
        justifyContent: center ? 'center' : end ? 'end' : between ? 'space-between' : 'start',
        gap: g,
        flexWrap: (wrap ? (reverse ? 'wrap-reverse' : 'wrap') : 'nowrap') as any,
        flexShrink: shrink ? 1 : 0,
        flexGrow: grow ? 1 : 0,
        alignItems: alignCenter ? 'center' : alignEnd ? 'end' : 'start',
        ...style,
    }
    const _className = classnames(className, props.g ? `gap-${props.g}` : '');
    return (
        <div
            {...{ style: _style, className: _className, ...rest }}
        >
            {props.children}
        </div>
    );
}

const width = (_: BoxProps) => _.wFullVw ? '100vw' : _.wFull ? '100%' : 'auto';
const height = (_: BoxProps) => _.hFullVh ? '100vh' : _.hFull ? '100%' : 'auto';
